import { Button } from '@rideiq/shared/components/Button';

export const FindSuggestionsButton = ({ onClick }) => {
  return (
    <Button color="secondary" onClick={onClick} sx={{ flexShrink: 0 }}>
      {'Find Ride Suggestions'}
    </Button>
  );
};
